import "./TermsConditions.css"

import MGButton from "../../../components/MGButton/MGButton";
import TermsConditionsListItem from "./TermsConditionsListItem";
import { useState } from "react";
import check_box_on from "../../../images/check_box_on.svg"
import check_box_off from "../../../images/check_box_off.svg"
import { ArrowLeft } from 'lucide-react';
export default function TermsConditions(
    {
        clickBack,
        clickContinue
    }
) {
    const [opened, setOpened] = useState({});
    const [isAccepted, setIsAccepted] = useState(false);

    const docs = [
        { id: 0, name: "Regulamento de Benefícios do Montepio Geral - Associação Mutualista", url: 'https://www.montepio.org/wp-content/uploads/2023/12/RB_Montepio_Geral_Associacao_Mutualista_2023-24.pdf' },
        { id: 1, name: "Estatutos", url: 'https://www.montepio.org/wp-content/uploads/2023/12/Estatutos_Montepio_Geral_Associacao_Mutualista_2023-24-1.pdf' }
    ];

    const documentClick = (id) => {
        setOpened((s) => ({ ...s, [id]: true }));
        const doc = docs.findLast((d) => (d.id == id));

        window.open(
            doc.url,
            "_blank",
            "noopener,noreferrer"
        );

    }

    const wasOpened = (id) => {
        return !!opened[id]
    }

    const allAccepted = () => {
        const all = docs.every((d) => opened[d.id]) && isAccepted

        return all;
    }

    return (

        <div className="TermsConditionsContainer">
            <div className="TermsConditionsHeader">
                <div className="QuotasHeader">
                    <ArrowLeft onClick={clickBack} />
                    <span>Termos e Condições</span>
                </div>
                <span className="QuotasHeader__description">Para continuar é necessária a leitura dos seguintes documentos:</span>
            </div>
            <div className="TermsConditionsBody">
                {docs.map((doc) => (
                    < TermsConditionsListItem id={doc.id} onClick={documentClick} document={doc.name} isOpened={wasOpened(doc.id)} />
                ))}
                <div className="TermsConditionsBody-term">
                    <img src={isAccepted ? check_box_on : check_box_off} onClick={() => (setIsAccepted(!isAccepted))} />
                    <span>Declaro que compreendi e aceitei que a regularização de quotas terá efeito sobre a conta de depósitos à ordem, onde habitualmente já são debitadas as minhas quotizações.</span>
                </div>
            </div>
            <div className="TermsConditionsFooter">
                <div>
                    <MGButton label="Continuar" type="primary" isEnable={allAccepted()} onClick={() => clickContinue()} />
                </div>
            </div>
        </div>
    );
}